<template>
  <v-overlay color="primary" opacity="1">
    <div class="d-flex flex-column align-center">
      <span
        class="
          white--text
          font-weight-thin
          d-flex
          text-h3
          flex-column
          pl-2
          pr-5
          mb-10
        "
        style="border: 2px solid white"
      >
        <span style="margin-bottom: -10px"
          ><span class="font-weight-regular text-h2">I</span>ONIAN</span
        >
        <span><span class="font-weight-regular text-h2">I</span>SLANDS</span>
      </span>

      <v-progress-circular
        size="100"
        indeterminate
        color="white"
      ></v-progress-circular>
    </div>
  </v-overlay>
</template>

<script>
export default {};
</script>

<style scoped lang="scss">
</style>